import React from 'react';
import s from './ListOfProductsTableGrid.module.css';

import {DepotProductType} from '../../../types/TypesStore';
type Props = {
	product: DepotProductType;
};
export const ListOfProductsTableRowElement: React.FC<Props> = ({product}) => {
	return (
		<div className={s.tableRow}>
			<div className={s.tableImageColumn}>
				<div className={s.productImage}>
					<img src={product.img} alt={product.name} />
				</div>
				<div className={s.productName}>{product.name}</div>
			</div>
			<div className={s.tableColumn}>2</div>
			<div className={s.tableColumn}>0</div>
			<div className={s.tableColumn}>+</div>
		</div>
	);
};

export default ListOfProductsTableRowElement;
